
export const AudioAnalyzerOptions = {
    fftSize: 1024 * 8,
    smoothingTime: 0.1,
    
    minDecibels: -100,
    maxDecibels: -0,

    // The max length of bins we need for processing.
    clearFrequencyMaxLength: 1024
};


export const BassSpectrumOptions = {
    spectrumStart: 3,
    spectrumEnd: 26,

    exponent: 10,
    root: 1,
    magnitudeTargetMax: 32,
    baseBarCount: 200
};


export const WideSpectrumOptions = {
    spectrumStart: 0,
    spectrumEnd: 225,

    exponent: 5,
    root: 2,
    magnitudeTargetMax: 150,
    baseBarCount: 200
};
